import { LocalStorageRepository } from "./LocalStorageRepository";

import { Todo } from "../../../../../types/types";
import { STORAGE_KEY_TODOS } from "../../../constants";

export class TodoLocalRepository extends LocalStorageRepository<Todo> {
    constructor() {
        super(STORAGE_KEY_TODOS);
    }

    findAllByListId(listId: string): Todo[] {
        return this.findAll().filter(todo => todo.listId === listId);
    }
}
